import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/contact/")({
  head: () => routeHead("/contact/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Contact />
  );
}
